import { Aggregator as AggregatorBase } from '../../bases/aggregator';
import { FEATURE_NAME } from './constants';
import { getConfigurationValue } from '../../state/init';

export class Aggregator extends AggregatorBase {
  constructor() {
    super({}, FEATURE_NAME);
    this.local_config = getConfigurationValue(
      `instruments.features.${FEATURE_NAME}.mapped_attributes`,
    );
  }

  getContext() {
    return super.getContext(FEATURE_NAME);
  }

  makeSnapshot() {
    return super.makeSnapshot(FEATURE_NAME);
  }
}
